import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=b0d4dea4&scoped=true&"
import script from "./Bookmarks.vue?vue&type=script&lang=js&"
export * from "./Bookmarks.vue?vue&type=script&lang=js&"
import style0 from "./Bookmarks.vue?vue&type=style&index=0&id=b0d4dea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d4dea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0d4dea4')) {
      api.createRecord('b0d4dea4', component.options)
    } else {
      api.reload('b0d4dea4', component.options)
    }
    module.hot.accept("./Bookmarks.vue?vue&type=template&id=b0d4dea4&scoped=true&", function () {
      api.rerender('b0d4dea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/components/Bookmarks.vue"
export default component.exports